import { ShieldCheck, Zap, Clock, Award } from 'lucide-react';
import { images } from '../../assets/images';

const features = [
  {
    icon: <ShieldCheck size={40} />,
    title: "Quality Assurance",
    desc: "Rigorous testing protocols ensuring zero-defect products."
  },
  {
    icon: <Zap size={40} />,
    title: "Advanced Technology",
    desc: "Using latest manufacturing tech for superior performance."
  },
  {
    icon: <Clock size={40} />,
    title: "Timely Delivery",
    desc: "Optimized supply chain for on-time project completion."
  },
  {
    icon: <Award size={40} />,
    title: "Industry Certified",
    desc: "Compliant with international safety and quality standards."
  }
];

const WhyChooseUs = () => {
  return (
    <section className="py-20 relative bg-slate-900 text-white overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{ backgroundImage: `url(${images.hero[2]})` }}
      ></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="text-orange-500 font-bold uppercase tracking-wider text-sm">Why Choose Us</span>
            <h2 className="text-3xl md:text-4xl font-bold mt-2 mb-6">
              Engineering Excellence You Can Rely On
            </h2>
            <p className="text-slate-300 mb-8 leading-relaxed">
              We combine decades of industry experience with cutting-edge technology to deliver 
              products that stand the test of time. Our commitment to customer satisfaction 
              drives everything we do.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              {features.map((feature, idx) => (
                <div key={idx} className="flex flex-col items-start">
                  <div className="text-orange-500 mb-4 bg-slate-800 p-3 rounded-lg">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                  <p className="text-slate-400 text-sm">{feature.desc}</p>
                </div>
              ))}
            </div>
          </div>
          
          <div className="hidden lg:block relative">
            <div className="absolute inset-0 border-2 border-orange-500 rounded-lg transform translate-x-4 translate-y-4"></div>
            <img 
              src={images.hero[0]} 
              alt="Quality Lab" 
              className="rounded-lg shadow-2xl relative z-10 w-full"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
